/* eslint-disable camelcase */
<template>
  <v-container
    tag="section"
  >
    <v-row>
      <v-col
        cols="12"
        class="px-0"
      >
        <v-tabs v-if="this.$route.params.id !== 'null'">
          <v-tab
            exact
            :to="`/customers/${$route.params.id}`"
          >
            {{ $t('key_data') }}
          </v-tab>
          <v-tab
            :to="`/customers/${$route.params.id}/options`"
          >
            {{ $t('options') }}
          </v-tab>
          <v-tab
            :to="`/customers/${$route.params.id}/balance`"
          >
            {{ $t('balance') }}
          </v-tab>
          <v-tab
            v-if="customer && customer.subscription"
            :to="{path: `/customers/${$route.params.id}/subscription`, query: { subscription_id: customer.subscription.id }}"
          >
            {{ $t('subscription') }}
          </v-tab>
          <v-tab
            :to="`/customers/${$route.params.id}/prices`"
          >
            {{ $t('prices') }}
          </v-tab>
          <v-tab
            :to="{path: `/labels`, query: { filters: { customer_id: $route.params.id } }}"
          >
            {{ $t('labels') }}
          </v-tab>
          <v-tab
            :to="`/customers/${$route.params.id}/actions`"
          >
            {{ $t('actions') }}
          </v-tab>
          <v-tab
            :to="{path: `/customers/${$route.params.id}/debtors`}"
          >
            {{ $t('debtors') }}
          </v-tab>
          <v-tab
            :to="{path: `/customers/${$route.params.id}/invoices`}"
          >
            {{ $t('invoices') }}
          </v-tab>
          <v-tab
            :to="`/customers/${$route.params.id}/card`"
          >
            {{ $t('customer_card') }}
          </v-tab>
          <v-tab
            :to="`/customers/${$route.params.id}/procedures`"
          >
            {{ $tc('procedure', 99) }}
          </v-tab>
          <v-tab
            :to="`/customers/${$route.params.id}/boardings`"
          >
            {{ $tc('boarding', 99) }}
          </v-tab>
          <v-tab
            :disabled="!(device_ids && device_ids.length)"
            :to="{path: `/customers/${$route.params.id}/devices`, query: { filters: { id: device_ids } }}"
          >
            {{ $t('devices') }}
          </v-tab>
        </v-tabs>
      </v-col>

      <customer-details
        v-if="!$route.params.view"
        :item="customer"
        :loading="loading"
        @save-customer="saveCustomer"
      />
      <customer-labels
        v-else-if="$route.params.view === 'labels' && $route.params.id !== 'null'"
        :loading="loading"
      />
      <customer-card
        v-else-if="$route.params.view === 'card' && $route.params.id !== 'null'"
        :loading="loading"
      />
      <customer-balance
        v-else-if="$route.params.view === 'balance' && $route.params.id !== 'null'"
        :loading="loading"
      />
      <customer-prices
        v-else-if="$route.params.view === 'prices' && $route.params.id !== 'null'"
        :loading="loading"
      />
      <customer-options
        v-else-if="$route.params.view === 'options' && $route.params.id !== 'null'"
        :loading="loading"
      />
      <customer-actions
        v-else-if="$route.params.view === 'actions' && $route.params.id !== 'null'"
        :loading="loading"
      />
      <customer-devices
        v-else-if="$route.params.view === 'devices' && $route.params.id !== 'null'"
        :loading="loading"
      />
      <customer-subscription
        v-else-if="$route.params.view == 'subscription' && this.$route.params.id !== 'null'"
        :loading="loading"
      />
      <customer-debtors
        v-else-if="$route.params.view == 'debtors' && this.$route.params.id !== 'null'"
        :loading="loading"
      />
      <customer-invoices
        v-else-if="$route.params.view == 'invoices' && this.$route.params.id !== 'null'"
        :loading="loading"
      />
      <customer-procedures
        v-else-if="$route.params.view == 'procedures' && this.$route.params.id !== 'null'"
        :loading="loading"
      />
      <customer-boardings
        v-else-if="$route.params.view == 'boardings' && this.$route.params.id !== 'null'"
        :loading="loading"
      />
    </v-row>
    <base-loading-overlay :loading="loading" />
  </v-container>
</template>
<script>
  import Edit from '@/mixins/Edit'
  import _ from 'lodash'
  import Qs from 'qs'

  export default {

    components: {
      CustomerLabels: () => import('../labels/List'),
      CustomerDevices: () => import('../app_devices/List'),
      CustomerSubscription: () => import('../payments/quickpay/subscription/Edit'),
    },
    mixins: [Edit],
    data () {
      return {
        customer: {
          name: '',
          support_note: '',
          billing_address: {
            name: '',
            company_name: '',
            street1: '',
            country: { id: 194, full_name: 'Denmark', iso: 'DK', iso3: 'DNK', numeric: '208', region: 'The North', zip_format: '^\\d{4}$', address_format: '{street_name} {street_number}, {zip_code} {city}, {state}, {country_name}', phone_prefix: '45', phone_format: '.+', active: true, created_at: '2018-07-19 12:20:04', updated_at: '2019-11-11 09:47:13', deleted_at: null },
            zip_code: '',
            city: '',
            email: '',
            phone: '',
          },
          shipping_address: {
            name: '',
            company_name: '',
            street1: '',
            country: { id: 194, full_name: 'Denmark', iso: 'DK', iso3: 'DNK', numeric: '208', region: 'The North', zip_format: '^\\d{4}$', address_format: '{street_name} {street_number}, {zip_code} {city}, {state}, {country_name}', phone_prefix: '45', phone_format: '.+', active: true, created_at: '2018-07-19 12:20:04', updated_at: '2019-11-11 09:47:13', deleted_at: null },
            zip_code: '',
            city: '',
            email: '',
            phone: '',
          },
          price_groups: [],
        },
        errors: [],
      }
    },
    computed: {
      labelQuery: function () {
        return Qs.stringify({ filters: { customer_id: { from: this.$route.params.id, to: this.$route.params.id } } }, { arrayFormat: 'brackets' })
      },
      device_ids: function () {
        return this.$_.map(this.customer.devices || [], d => d.id)
      },
    },
    methods: {
      load: function () {
        if (this.$route.params.id !== 'null') {
          this.loading = true
          this.$get(`/customers/${this.$route.params.id}`)
            .then(response => {
              this.customer = response.data
              this.loading = false
            })
            .catch(e => {
              this.loading = false
            })
        }
      },
      saveCustomer: function () {
        this.loading = true

        this.$post(`/customers/${this.customer.id || ''}`, this.customer)
          .then(response => {
            this.$toast(`${this.$t('customer')} ${this.$t('saved_correctly')}`)

            this.loading = false
          })
          .catch(() => {
            this.loading = false
          })
      },
    },
  }
</script>
